export const findRelevantVertice = (vertices, line, fireplace) => {
  let result = [null, null]
  let lengthTopBottom = []
  let lengthLeftRight = []


  const sortedVertices = vertices.sort((a, b) => {
    const startXA = Math.min(a.points[0].x, a.points[1].x)
    const endXA = Math.max(a.points[0].x, a.points[1].x)
    const startYA = Math.min(a.points[0].y, a.points[1].y)
    const startXB = Math.min(b.points[0].x, b.points[1].x)
    const endXB = Math.max(b.points[0].x, b.points[1].x)
    const startYB = Math.min(b.points[0].y, b.points[1].y)

    if (startXA !== startXB) {
      return startXA - startXB
    } else if (endXA !== endXB) {
      return endXA - endXB
    } else {
      return startYA - startYB
    }
  })

  for (const verticeTwo of sortedVertices) {
    if (
      Math.abs(line.points[0].x - line.points[1].x) > 0 &&
      Math.abs(verticeTwo.points[0].x - verticeTwo.points[1].x) > 0 &&
      line !== verticeTwo &&
      isSubpart(
        (line.points[0].x + line.points[1].x) / 2,
        verticeTwo.points[0].x,
        verticeTwo.points[1].x
      )
    ) {
      lengthTopBottom.push(verticeTwo)
      result[1] = line.points[0].y < verticeTwo.points[0].y ? 'top' : 'bottom'
    } else if (
      Math.abs(line.points[0].y - line.points[1].y) > 0 &&
      Math.abs(verticeTwo.points[0].y - verticeTwo.points[1].y) > 0 &&
      line !== verticeTwo &&
      isSubpart(
        (line.points[0].y + line.points[1].y) / 2,
        verticeTwo.points[0].y,
        verticeTwo.points[1].y
      )
    ) {
      lengthLeftRight.push(verticeTwo)
      result[1] = line.points[0].x < verticeTwo.points[0].x ? 'left' : 'right'
    }
  }

  if (result[1] === 'left' || result[1] === 'right') {
    if (result[1] === 'left') {
      let dummyFirePlaceX = fireplace?.position.x - 2
      const organizedPoints = organizeLines(
        JSON.parse(JSON.stringify(vertices))
      )
      let dummyFirePlaceY = fireplace?.position.y

      if (
        isPointInsidePolygon(organizedPoints, [
          dummyFirePlaceX,
          dummyFirePlaceY
        ])
      ) {
        result[1] = 'right'
      }
    } else if (result[1] === 'right') {
      let dummyFirePlaceX = fireplace.position.x + 2
      let dummyFirePlaceY = fireplace.position.y
      const organizedPoints = organizeLines(
        JSON.parse(JSON.stringify(vertices))
      )

      if (
        isPointInsidePolygon(organizedPoints, [
          dummyFirePlaceX,
          dummyFirePlaceY
        ])
      ) {
        result[1] = 'left'
      }
    }
  } else {
    if (result[1] === 'top') {
      let dummyFirePlaceX = fireplace.position.x
      const organizedPoints = organizeLines(
        JSON.parse(JSON.stringify(vertices))
      )
      let dummyFirePlaceY = fireplace.position.y - 2

      if (
        isPointInsidePolygon(organizedPoints, [
          dummyFirePlaceX,
          dummyFirePlaceY
        ])
      ) {
        result[1] = 'bottom'
      }
    } else if (result[1] === 'bottom') {
      let dummyFirePlaceX = fireplace.position.x
      let dummyFirePlaceY = fireplace.position.y + 2
      const organizedPoints = organizeLines(
        JSON.parse(JSON.stringify(vertices))
      )

      if (
        isPointInsidePolygon(organizedPoints, [
          dummyFirePlaceX,
          dummyFirePlaceY
        ])
      ) {
        result[1] = 'top'
      }
    }
  }

  return result
}

const isSubpart = (value, start, end) => {
  return value >= Math.min(start, end) && value <= Math.max(start, end)
}

export function organizeLines (lines) {
  const sortedPoints = []
  if (lines?.length === 0) {
    return sortedPoints
  }
  let leastPoint = lines[0].points[0]
  for (const line of lines) {
    for (const point of line.points) {
      if (
        point &&
        (point.x < leastPoint.x ||
          (point.x === leastPoint.x && point.y < leastPoint.y))
      ) {
        leastPoint = point
      }
    }
  }
  function removeLine (line) {
    const index = lines.indexOf(line)
    if (index !== -1) {
      lines.splice(index, 1)
    }
  }
  while (lines?.length > 0) {
    for (const line of lines) {
      for (const point of line.points) {
        if (point && point.x === leastPoint.x && point.y === leastPoint.y) {
          sortedPoints.push([leastPoint.x, leastPoint.y])
          sortedPoints.push([point.x, point.y])
          leastPoint =
            point === line.points[0] ? line.points[1] : line.points[0]
          removeLine(line)
          break
        }
      }
    }
  }
  return removeDuplicatesWithOrder(sortedPoints)
}

function removeDuplicatesWithOrder (input) {
  const seen = new Set()
  const result = []
  for (const item of input) {
    const strItem = JSON.stringify(item)
    if (!seen.has(strItem)) {
      result.push(item)
      seen.add(strItem)
    }
  }
  return result
}

export function isPointInsidePolygon (polygon, point) {
  const n = polygon.length
  let oddIntersections = false
  for (let i = 0; i < n; i++) {
    const j = (i + 1) % n
    if (isPointOnSegment(polygon[i], polygon[j], point)) {
      return true
    }
    if (
      polygon[i][1] > point[1] !== polygon[j][1] > point[1] &&
      point[0] <
        ((polygon[j][0] - polygon[i][0]) * (point[1] - polygon[i][1])) /
          (polygon[j][1] - polygon[i][1]) +
          polygon[i][0]
    ) {
      oddIntersections = !oddIntersections
    }
  }
  return oddIntersections
}

export function isPointOnSegment (segStart, segEnd, point) {
  const [x1, y1] = segStart
  const [x2, y2] = segEnd
  const [x, y] = point
  return (
    Math.abs((x2 - x1) * (y - y1) - (x - x1) * (y2 - y1)) < Number.EPSILON &&
    (x - x1) * (x2 - x) + (y - y1) * (y2 - y) >= 0 &&
    (x - x2) * (x1 - x) + (y - y2) * (y1 - y) >= 0
  )
}
